"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _breakpoints = require("../../constants/breakpoints");

var _CustomerYAxis = _interopRequireDefault(require("./CustomerYAxis"));

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _Lightning = _interopRequireDefault(require("../Icons/Lightning"));

var _colors = require("./colors");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  max-width: 100vw;\n  position: relative;\n"])));

var ChartWrapper = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  height: ", ";\n  width: ", ";\n  margin-bottom: 15px;\n  @media only screen and (max-width: ", ") {\n    height: 300px;\n    width: ", ";\n  }\n"])), function (props) {
  return props.chartHeight;
}, function (props) {
  return props.widths.desktop;
}, _breakpoints.MAX_DESKTOP_BREAKPOINT, function (props) {
  return props.widths.mobile;
});

var Left = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow-x: ", ";\n  width: calc(100vw - 80px);\n\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n    border-radius: 8px;\n    background-color: #f2f2f2;\n  }\n\n  &::-webkit-scrollbar:vertical {\n    width: 0px;\n  }\n\n  &::-webkit-scrollbar:horizontal {\n    height: 9px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    background-color: #c4c4c4;\n  }\n"])), function (_ref) {
  var enableOverflowX = _ref.enableOverflowX;
  return enableOverflowX ? 'visible' : 'auto';
});

var Right = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 80px;\n  height: 400px;\n  @media only screen and (max-width: ", ") {\n    height: 300px;\n  }\n"])), _breakpoints.MAX_DESKTOP_BREAKPOINT);

var StyledLightning = (0, _styled["default"])(_Lightning["default"])(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: 4px;\n"])));

var ScrollableXYPlot = function ScrollableXYPlot(_ref2) {
  var children = _ref2.children,
      hasNoData = _ref2.hasNoData,
      isBattery = _ref2.isBattery,
      roundedMaxValue = _ref2.roundedMaxValue,
      tickValues = _ref2.tickValues,
      widths = _ref2.widths,
      enableOverflowX = _ref2.enableOverflowX,
      chartHeight = _ref2.chartHeight;
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(Right, null, /*#__PURE__*/_react["default"].createElement(_CustomerYAxis["default"], {
    hasNoData: hasNoData,
    yAxisLabel: !isBattery ? 'kWh' : null,
    roundedMaxValue: isBattery ? 100 : roundedMaxValue,
    tickValues: tickValues,
    handleTickFormat: function handleTickFormat(tick) {
      return /*#__PURE__*/_react["default"].createElement("div", null, isBattery && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledLightning, {
        color: tick === 0 ? _colors.WEATHER_ICON_COLOR : _colors.BATTERY
      }), /*#__PURE__*/_react["default"].createElement("span", null, "".concat(tick, "%"), /*#__PURE__*/_react["default"].createElement("br", null), "0 kWh")), !isBattery && "".concat(tick));
    }
  })), /*#__PURE__*/_react["default"].createElement(Left, {
    enableOverflowX: enableOverflowX
  }, /*#__PURE__*/_react["default"].createElement(ChartWrapper, {
    widths: widths,
    chartHeight: chartHeight
  }, children)));
};

ScrollableXYPlot.propTypes = {
  children: _propTypes["default"].node.isRequired,
  hasNoData: _propTypes["default"].bool,
  isBattery: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  roundedMaxValue: _propTypes["default"].number.isRequired,
  tickValues: _propTypes["default"].arrayOf(_propTypes["default"].number),
  widths: _propTypes["default"].shape({
    desktop: _propTypes["default"].string.isRequired,
    mobile: _propTypes["default"].string.isRequired
  }).isRequired,
  enableOverflowX: _propTypes["default"].bool,
  chartHeight: _propTypes["default"].string
};
ScrollableXYPlot.defaultProps = {
  hasNoData: false,
  isBattery: false,
  onClick: undefined,
  onMouseLeave: null,
  tickValues: [],
  enableOverflowX: false,
  chartHeight: '400px'
};
var _default = ScrollableXYPlot;
exports["default"] = _default;